export default __webpack_public_path__ + "static/media/ntb.f9b1e5f7.svg";